import type { VfConfig } from '#types/config/components/vf'
import type { RecursivePartial } from '#types/utils'

export default {
  brandClasses: {
    panel: {
      header: 'title-3 p-4 b-b b-grey-70 lg:px-6'
    },
    modal: {
      header: 'subtitle-1',
      wrapper: 'pt-4'
    }
  }
} satisfies RecursivePartial<VfConfig['dialog']>
